import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'rtmTripSignalValues',
  initialState: {},
  reducers: {
    setSignalValues: (state, { payload }) => {
      state[`${payload.tripId}-${payload.signalId}`] = {
        data: payload.data,
        vTable: payload.vTable,
      }
    },
  },
})

export const { setSignalValues } = slice.actions

export default slice.reducer

export const selectSignalValues = (tripId, signalId) => (state) =>
  state.rtmTripSignalValues[`${tripId}-${signalId}`]?.data

export const selectSignalVTable = (tripId, signalId) => (state) =>
  state.rtmTripSignalValues[`${tripId}-${signalId}`]?.vTable
